import { apiSetJwt } from '../../lib/api';

function parseToken(token) {
  if (!token) return;

  return JSON.parse(atob(token.split('.')[1]));
}

const state = {
  userLogged: false,
  currentUser: {},
};

const getters = {
  currentUser: st => st.currentUser,
  isAdmin: st => st.currentUser.roles.includes('ROLE_ADMIN'),
  getUserLogged: st => st.userLogged,
};

const mutations = {
  setUser(state, { token }) {
    state.userLogged = true;
    state.currentUser = { ...parseToken(token) };
    apiSetJwt(token);
  },

  logout(state) {
    state.currentUser = {};
    state.userLogged = false;
    apiSetJwt('');
  },
};

const actions = {
  logout({ commit }) {
    commit('auth/clearUserToken', {}, { root: true });
    commit('logout');
  },
};

export default { namespaced: true, actions, state, mutations, getters };
